/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Pricing_Experiment_OverrideInputs */

const en_pricing_experiment_override = /** @type {(inputs: Pricing_Experiment_OverrideInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Override ${i?.name}`)
};

const es_pricing_experiment_override = /** @type {(inputs: Pricing_Experiment_OverrideInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cambiar ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Override {name}" |
*
* @param {Pricing_Experiment_OverrideInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_experiment_override = /** @type {((inputs: Pricing_Experiment_OverrideInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Experiment_OverrideInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_experiment_override(inputs)
	return en_pricing_experiment_override(inputs)
});